import { render } from "./SettingsView.vue?vue&type=template&id=f36695d0&ts=true"
import script from "./SettingsView.vue?vue&type=script&lang=ts"
export * from "./SettingsView.vue?vue&type=script&lang=ts"

import "./SettingsView.vue?vue&type=style&index=0&id=f36695d0&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__